module.exports = function(video) {
	'use strict'
	video.directive('newVideoDir',newVideoDir);
	newVideoDir.$inject=[];
	function newVideoDir() {
		return {
			template: require('./partial/new-video.html'),
			controller:"newVideoController",
			controllerAs:"vmnv",
			link: function(scope, element, attrs, ctrl) {
				    
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/new-video/js/directive/newVideoDirective.js
// module id = 642
// module chunks = 0